<template>
  <section id="home" class="home">
    <!-- 模块一至六：整屏滚动渐入模块 -->
    <div
      v-for="(item, index) in sections"
      :key="item.key"
      class="fullscreen-section reveal-section"
      :class="{ 'is-visible': visibleMap[index] }"
    >
      <!-- 设计稿画布：固定1920×1080，随窗口尺寸与浏览器缩放等比缩放 -->
      <div class="section-canvas" :style="{ transform: 'scale(' + scale + ')' }">
        <!-- 背景图：置于动效容器之外，不参与渐入动效（如模块一 home-back@2x.png 始终直接显示） -->
        <img v-if="item.bgImage" :src="item.bgImage" class="section-bg" />
        <div class="section-inner">
          <!-- 上层图：手机端优先用 srcMobile（如模块三竖屏人物图），无则按语言选图 -->
          <img
            v-for="overlay in item.overlays"
            :key="overlay.className"
            :src="isMobile && overlay.srcMobile ? overlay.srcMobile : (overlay.srcEn && $i18n.locale === 'en' ? overlay.srcEn : overlay.src)"
            class="section-img"
            :class="overlay.className"
          />
          <!-- 模块一小标语（原 home-1-smallword.png，改为 HTML 文字渲染） -->
          <div v-if="item.key === 'hero'" class="hero-smallword">
            <span>{{ $t('home.smallword1') }}</span>
            <span class="smallword-divider">|</span>
            <span>{{ $t('home.smallword2') }}</span>
            <span class="smallword-divider">|</span>
            <span>{{ $t('home.smallword3') }}</span>
          </div>
          <!-- 模块一文字 -->
          <div v-if="item.key === 'hero'" class="hero-text">
            <h1 class="hero-title">{{ $t('home.heroTitle') }}</h1>
            <h2 class="hero-subtitle">{{ $t('home.heroSubtitle') }}</h2>
            <router-link to="/product" class="hero-btn">{{ $t('home.heroBtn') }} &gt;</router-link>
          </div>
          <!-- 模块二文字 -->
          <div v-if="item.key === 'daynight'" class="section-text">
            <h2 class="section-title">{{ $t('home.serviceTitle') }}</h2>
            <p class="section-desc">{{ mobileText($t('home.serviceDesc')) }}</p>
            <router-link to="/service" class="section-btn">{{ $t('home.serviceBtn') }}<span class="btn-arrow"></span></router-link>
          </div>
          <!-- 模块三文字 -->
          <div v-if="item.key === 'app'" class="app-text">
            <h2 class="app-title">{{ $t('home.missionTitle') }}</h2>
            <p class="app-desc">{{ mobileText($t('home.missionDesc')) }}</p>
          </div>
          <!-- 模块四文字 -->
          <div v-if="item.key === 'share'" class="share-text">
            <h2 class="share-main-title">{{ $t('home.shareTitle') }}</h2>
            <div class="share-divider"></div>
            <div class="share-content">
              <h3 class="share-subtitle">{{ $t('home.shareSubtitle') }}</h3>
              <p class="share-desc">{{ mobileText($t('home.shareDesc')) }}</p>
            </div>
          </div>
          <!-- 模块五文字 -->
          <div v-if="item.key === 'mode'" class="mode-text">
            <h2 class="mode-title">{{ $t('home.modeTitle') }}</h2>
            <div class="mode-divider"></div>
            <p class="mode-desc">{{ mobileText($t('home.modeDesc')) }}</p>
          </div>
          <!-- 模块六文字 -->
          <div v-if="item.key === 'extra'" class="extra-text">
            <h2 class="extra-title">{{ $t('home.extraTitle') }}</h2>
            <div class="extra-divider"></div>
            <div class="extra-card">
              <h3 class="extra-card-title">{{ $t('home.extraCardTitle') }}</h3>
              <p class="extra-card-desc">{{ mobileText($t('home.extraCardDesc')) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      scale: 1,
      baseZoom: 1,
      sections: [
        {
          key: 'hero',
          bgImage: require('@/assets/images/home/home-back@2x.png'),
          overlays: [
            { src: require('@/assets/images/home/home-1-cgm@2x.png'), srcEn: require('@/assets/images/home/home-1-INTcgm@2x.png'), className: 'section-overlay-hero' },
            { src: require('@/assets/images/home/home-1-small.png'), srcEn: require('@/assets/images/home/home-1-INTsmall.png'), className: 'section-overlay-hero-small' }
          ]
        },
        {
          key: 'daynight',
          overlays: [
            {
              src: require('@/assets/images/home/home-2-people.png'),
              srcEn: require('@/assets/images/home/home-2-INTpeople.png'),
              className: 'section-overlay-daynight'
            }
          ]
        },
        {
          key: 'app',
          overlays: [
            { src: require('@/assets/images/home/home-3-person.png'), srcMobile: require('@/assets/images/home/home-3-person-mobile.png'), className: 'section-overlay-app' },
            { src: require('@/assets/images/home/home-3-green.png'), className: 'section-overlay-app-green' }
          ]
        },
        {
          key: 'share',
          overlays: [
            { src: require('@/assets/images/home/home-4-people.png'), className: 'section-overlay-share' }
          ]
        },
        {
          key: 'mode',
          overlays: [
            { src: require('@/assets/images/home/home-5-earth.png'), className: 'section-overlay-mode' }
          ]
        },
        {
          key: 'extra',
          overlays: [
            { src: require('@/assets/images/home/home-6-person.png'), className: 'section-overlay-extra-person' },
            { src: require('@/assets/images/home/home-6-green.png'), className: 'section-overlay-extra-green' },
            { src: require('@/assets/images/home/home-6-diamond.png'), className: 'section-overlay-extra-diamond' }
          ]
        }
      ],
      visibleMap: {},
      observer: null,
      isMobile: false,
      mobileQuery: null
    }
  },
  mounted() {
    // 记录初始浏览器缩放基准，后续 Ctrl +/- 缩放时据此补偿，避免缩放被视口变化抵消
    this.baseZoom = window.devicePixelRatio || 1
    this.updateScale()
    window.addEventListener('resize', this.updateScale)
    // 断点监听：手机端文案需去掉桌面排版用的 \n（CSS normal 会把它折叠成可见空格）
    this.mobileQuery = window.matchMedia('(max-width: 1024px)')
    this.isMobile = this.mobileQuery.matches
    if (this.mobileQuery.addEventListener) {
      this.mobileQuery.addEventListener('change', this.onMobileChange)
    } else if (this.mobileQuery.addListener) {
      this.mobileQuery.addListener(this.onMobileChange)
    }
    this.initObserver()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScale)
    if (this.mobileQuery) {
      if (this.mobileQuery.removeEventListener) {
        this.mobileQuery.removeEventListener('change', this.onMobileChange)
      } else if (this.mobileQuery.removeListener) {
        this.mobileQuery.removeListener(this.onMobileChange)
      }
    }
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },
  methods: {
    onMobileChange(e) {
      this.isMobile = e.matches
    },
    mobileText(text) {
      // 文案换行标记约定：\n = 桌面排版换行，| = 手机端专用换行（可逐条单独控制）
      // 手机端：去掉 \n、把 | 变真换行（配合 white-space: pre-line）；桌面：去掉 |（\n 原样保留）
      return this.isMobile
        ? String(text).replace(/\n/g, '').replace(/\|/g, '\n')
        : String(text).replace(/\|/g, '')
    },
    updateScale() {
      // 按视口与1920×1080设计稿的比例取较大值（cover模式），
      // 保证画布始终铺满窗口不留白，非16:9窗口时边缘居中裁切
      const fit = Math.max(window.innerWidth / 1920, window.innerHeight / 1080)
      // 浏览器 Ctrl +/- 缩放会同步改变视口尺寸（等比抵消），
      // 通过 devicePixelRatio 计算当前缩放倍数并补偿，使内容随浏览器缩放同步变大变小
      const zoom = (window.devicePixelRatio || 1) / this.baseZoom
      this.scale = fit * zoom
    },
    initObserver() {
      if (!('IntersectionObserver' in window)) {
        // 不支持 IntersectionObserver 时直接全部显示
        this.sections.forEach((item, index) => {
          this.$set(this.visibleMap, index, true)
        })
        return
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index)
          this.$set(this.visibleMap, index, entry.isIntersecting)
        })
      }, {
        threshold: 0.15
      })
      this.$nextTick(() => {
        const els = this.$el.querySelectorAll('.reveal-section')
        els.forEach((el, index) => {
          el.dataset.index = index
          this.observer.observe(el)
        })
      })
    }
  }
}
</script>

<style scoped>
.home {
  background: #FFFFFF;
}

/* 全屏高度纵向模块，配合页面级 scroll-snap 实现整屏吸附切页 */
.fullscreen-section {
  height: 100vh;
  /* 手机端用 JS 实时写入的可见高度（App.vue），避免 100vh 高于可见区导致底部裁切；桌面不受影响 */
  height: var(--app-height, 100vh);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.reveal-section {
  position: relative;
  background: #FFFFFF;
}

/* 模块二、四、六：灰色背景 */
.reveal-section:nth-child(2),
.reveal-section:nth-child(4),
.reveal-section:nth-child(6) {
  background: #F5F5F5;
}

/* 设计稿画布：六个模块共用的固定尺寸容器，整体等比缩放 */
.section-canvas {
  position: relative;
  width: 1920px;
  height: 1080px;
  flex-shrink: 0;
  transform-origin: center center;
}

.reveal-section .section-inner {
  position: relative;
  width: 100%;
  height: 100%;
  /* 渐入动效：初始透明并轻微下移；隐藏态不设过渡，离开视口瞬间重置，
     保证每次切页切回来都完整重播渐入 */
  opacity: 0;
  transform: translateY(48px);
  will-change: opacity, transform;
}

.reveal-section.is-visible .section-inner {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* 背景图：铺满画布；位于动效容器 .section-inner 之外，不参与渐入动效 */
.section-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 上层图公共样式：绝对定位、保持原始比例，各类只负责位置与尺寸上限 */
.section-img {
  position: absolute;
  width: auto;
  height: auto;
  margin: auto;
}

/* 模块一：上层CGM图 */
.section-overlay-hero {
  max-width: 50%;
  max-height: 45%;
  top: 15%;
  left: 40%;
  right: 0;
  bottom: 0;
}

/* 模块一：上层小图 */
.section-overlay-hero-small {
  max-width: 25%;
  max-height: 30%;
  top: 15%;
  left: 0;
  right: 35%;
  bottom: 0;
}

/* 仅英文生效：英文版小图（home-1-INTsmall.png）单独调大小，
   只改需要差异的 max-width/max-height，位置等其他属性继承上方默认样式 */
:lang(en) .section-overlay-hero-small {
  max-width: 25%;
  max-height: 30%;
}

/* 仅英文生效：英文版 home-1-INTsmall.png 单独调大小，
   只改 max-width/max-height 数值，位置等其他属性继承上方默认样式 */
:lang(en) .section-overlay-hero-small {
  max-width: 27%;
  max-height: 30%;
}



/* 模块二：上层人物图 */
.section-overlay-daynight {
  max-width: 70%;
  max-height: 90%;
  top: 10%;
  left: 40%;
  right: 0;
  bottom: 0;
}

/* 仅英文生效：英文版 home-2-INTpeople.png 单独调大小与位置，
   只改需要差异的属性，其余继承上方默认样式 */
:lang(en) .section-overlay-daynight {
  max-width: 60%;
  top: 15%;
  max-height: 75%;
  top: 10%;
  left: 40%;
  right: 0;
  bottom: 0;
}

/* 模块三：上层插图 */
.section-overlay-app {
  max-width: 65%;
  max-height: 67%;
  top: 8%;
  left: 0;
  right: 50%;
  bottom: 0;
}

/* 模块三：青色色块卡片 */
.section-overlay-app-green {
  max-width: 47.4%;
  max-height: 60%;
  top: 8%;
  left: 52.55%;
  right: 0;
  bottom: 0;
}

/* 模块三：文字（青色卡片上，与卡片同区域垂直居中） */
.app-text {
  position: absolute;
  top: 8%;
  left: 62%;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}

.app-title {                /* 标题：“我们的使命” */
  font-size: 50px;
  font-weight: 500;
  color: #FFFFFF;
  margin: 0 0 30px 0;
  line-height: 1.4;
}

.app-desc {                 /* 使命描述 */
  font-size: 24px;
  font-weight: 400;
  color: #FFFFFF;
  margin: 0;
  line-height: 1.8;
  white-space: pre-line;
}

/* 模块三动效独立拆分：大标题（.app-title）与小标题/描述（.app-desc）各自叠加独立入场动效，
   透明度与父层 .section-inner 相乘生效；隐藏态不设过渡，切页离开瞬间重置，切回来完整重播 */

/* 模块三：大标题（“我们的使命”）入场；
   改 0.8s 调动画时长，改末尾 0s 调延迟，改 translateY(24px) 调上移幅度 */
.reveal-section .app-text .app-title {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .app-text .app-title {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.2s ease 0s,
    transform 1.2s ease 0s;
}

/* 模块三：小标题/描述（使命描述文字）入场——默认比大标题晚出现；
   改 0.8s 调动画时长，改末尾 0.4s 调延迟（晚多久出现） */
.reveal-section .app-text .app-desc {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .app-text .app-desc {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.4s,
    transform 0.8s ease 0.4s;
}

/* 模块三：青色卡片图（home-3-green.png）入场——渐入上移；
   改 0.8s 调动画时长，改末尾 0s 调延迟，改 translateY(24px) 调上移幅度 */
.reveal-section .section-overlay-app-green {
  opacity: 0;
  transform: translateY(40px);
  /* 隐藏态不设过渡，离开视口瞬间重置，切回来完整重播 */
}

.reveal-section.is-visible .section-overlay-app-green {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0s,
    transform 0.8s ease 0s;
}

/* 模块四：上层人物图 */
.section-overlay-share {
  max-width: 50%;
  max-height: 50%;
  top: 20%;
  left: 30%;
  right: 0;
  bottom: 0;
}

/* 模块五：上层插图 */
.section-overlay-mode {
  max-width: 50%;
  max-height: 70%;
  top: 28%;
  left: 5%;
  right: 0;
  bottom: 0;
}

/* 模块六：人物图 */
.section-overlay-extra-person {
  max-width: 35%;
  max-height: 50%;
  top: 20%;
  left: 0;
  right: 35%;
  bottom: 0;
}

/* 模块六：绿色卡片图 */
.section-overlay-extra-green {
  max-width: 35%;
  max-height: 50%;
  top: 20%;
  left: 35%;
  right: 0;
  bottom: 0;
}

/* 模块六：钻石图标 */
.section-overlay-extra-diamond {
  max-width: 70px;
  max-height: 70px;
  top: 42%;
  left: 52.5%;
  z-index: 10;
}

/* 模块一：文字 */
.hero-text {
  position: absolute;
  top: 29%;
  left: 20%;
  z-index: 10;
}

.hero-title {                 /* 主标题：“可孚孚探®” */
  font-size: 50px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0 0 10px 0;
  line-height: 1.2;
}

.hero-subtitle {              /* 副标题：“持续葡萄糖监测系统” */
  font-size: 50px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.5;
}

.hero-btn {                   /* “了解更多”按钮 */
  display: inline-block;
  margin-top: 290px;
  padding: 14px 36px;
  background-color: #00ADBB;
  color: #FFFFFF;
  font-size: 30px;
  font-weight: 400;
  border-radius: 57px;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

.hero-btn:hover {
  background-color: #009999;
}

/* 模块一动效独立拆分：渲染文字（.hero-text）与小图 home-1-small.png 跟随 .section-inner
   整体渐入（保持现状），按钮与 CGM 图在下方叠加各自的入场动效，透明度与父层相乘生效 */

/* 模块一：“了解更多”按钮入场——比渲染文字晚出现；
   改 transition-delay（0.8s）调晚多久出现，改前面的 0.8s 调动画时长 */
.reveal-section .hero-btn {
  opacity: 0;
  transform: translateY(24px);
  /* 隐藏态不设入场过渡（离开视口瞬间重置），悬停变色仍保持 0.3s */
  transition: background-color 0.3s ease;
}

.reveal-section.is-visible .hero-btn {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.4s,
    transform 0.8s ease 0.4s,
    background-color 0.3s ease;   /* 悬停变色保持 0.3s 不延迟 */
}

/* 模块一：CGM 图（home-1-cgm@2x.png）入场——从小到大淡入；
   改 scale(0.5) 调起始大小（越接近1变化越小） */
.reveal-section .section-overlay-hero {
  opacity: 0;
  transform: scale(0.8);
  /* 隐藏态不设过渡，离开视口瞬间回到缩小状态，切回来完整重播从小到大 */
}

.reveal-section.is-visible .section-overlay-hero {
  opacity: 1;
  transform: scale(1);
  transition: opacity 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s,
    transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
}

/* 模块一：小标语文字*/
.hero-smallword {
  position: absolute;
  top: 0;
  left: 0;
  right: 37.5%;
  bottom: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 400;
  color: #B3B3B3;
  letter-spacing: 2px;
  white-space: nowrap;
  z-index: 11;
  /* 容器不拦截鼠标*/
  pointer-events: none;
}

.hero-smallword span {
  pointer-events: auto;
}

.smallword-divider {
  margin: 0 24px;
}

/* 仅英文生效：模块一小标语（Real-Time Protection | Remote Care | Finger-Prick Free）
   三个词字号统一，只改 font-size 数值；词间距调 .smallword-divider 的 margin；
   位置用 transform: translate(x, y) 单独微调，x 正值右移、y 正值下移，中文版不受影响 */
:lang(en) .hero-smallword {
  font-size: 22px;
  transform: translate(80px, 0);
}

/* 仅英文生效：小标语三个词之间的间距（| 分隔符两侧），
   改 margin 左右数值即可，越大词与词离得越远 */
:lang(en) .smallword-divider {
  margin: 0 2px;
}

/* 模块二：文字 */
.section-text {
  position: absolute;
  top: 23%;
  left: 18%;
  z-index: 10;
  max-width: 45%;
}

.section-title {              /* 标题：“服务与支持” */
  font-size: 50px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0 0 40px 0;
  line-height: 1.3;
}

.section-desc {
  font-size: 24px;
  font-weight: 400;
  color: #B3B3B3;
  margin: 0 0 60px 0;
  line-height: 1.6;
  white-space: pre-line;
}

/* 仅英文生效：模块二介绍文字左右两端对齐；
   中文版含 \n 强制换行，两端对齐会拉大字间距故不加 */
:lang(en) .section-desc {
  text-align: justify;
}

/* 仅英文生效：缩小模块二文字容器宽度，避免文字盖到右侧人物图，
   数值可改，越小文字块越窄 */
:lang(en) .section-text {
  max-width: 32%;
}

.section-btn {                /* "点击查看"按钮 */
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 12px 28px;
  background-color: transparent;
  color: #1a1a1a;
  font-size: 24px;
  font-weight: 400;
  border: 2px solid #252525;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.3s ease;
}

/* 箭头：横线 + 右上斜线（'>' 的上半部分） */
.btn-arrow {
  display: inline-block;
  top: 3px;
  width: 20px;
  height: 2px;
  background: currentColor;
  position: relative;
  vertical-align: middle;
}

.btn-arrow::after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  width: 12px;
  height: 2px;
  background: currentColor;
  transform-origin: right center;
  transform: rotate(40deg);
}

.section-btn:hover {
  background-color: #1a1a1a;
  color: #FFFFFF;
}

/* 模块二动效独立拆分：渲染文字（标题+描述）、人物图（home-2-people.png）、“点击查看”按钮
   各自叠加独立入场动效，透明度与父层 .section-inner 相乘生效；
   隐藏态均不设过渡，切页离开瞬间重置，切回来完整重播 */

/* 模块二：渲染文字（.section-title 标题 + .section-desc 描述）入场；
   改 0.8s 调动画时长，改末尾 0s 调延迟（多久后出现） */
.reveal-section .section-text .section-title,
.reveal-section .section-text .section-desc {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .section-text .section-title,
.reveal-section.is-visible .section-text .section-desc {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0s,
    transform 0.8s ease 0s;
}

/* 模块二：“点击查看”按钮入场——比渲染文字晚出现 */
.reveal-section .section-btn {
  opacity: 0;
  transform: translateY(12px);
  /* 隐藏态不设入场过渡（离开视口瞬间重置），悬停变色仍保持 0.3s */
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

.reveal-section.is-visible .section-btn {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.6s ease 0.4s,
    transform 0.6s ease 0.4s,
    background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;  /* 悬停变色保持 0.3s 不延迟 */
}

/* 模块二：人物图（home-2-people.png）入场——保持之前的渐入上移效果（不从小到大）；
   改 0.8s 调动画时长，改末尾 0s 调延迟，改 translateY(24px) 调上移幅度 */
.reveal-section .section-overlay-daynight {
  opacity: 0;
  transform: translateY(24px);
  /* 隐藏态不设过渡，离开视口瞬间重置，切回来完整重播 */
}

.reveal-section.is-visible .section-overlay-daynight {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.0s ease 0s,
    transform 1.6s ease 0s;
}

/* 模块四：文字 */
.share-text {                 /* 文字容器，占满整个模块 */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.share-main-title {
  text-align: center;
  font-size: 42px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0;
  padding-top: 12%;
  line-height: 0.1;
}

.share-divider {              /* 标题下方的分割线 */
  width: 330px;
  height: 1px;
  background-color: #1a1a1a;
  margin: 50px auto 0;
}

.share-content {              /* 左下内容区域容器 */
  position: absolute;
  bottom: 20%;
  left: 22%;
  max-width: 40%;
}

/* 仅英文生效：缩小模块四文字容器宽度，避免盖到右侧人物图，数值可改 */
:lang(en) .share-content {
  max-width: 36%;
}

/* 仅英文生效：模块四文字容器下移调节点（选择器与动效规则同级，防止被覆盖） */
:lang(en) .reveal-section .share-text .share-content {
  transform: translateY(120px);
}

:lang(en) .reveal-section.is-visible .share-text .share-content {
  transform: translateY(80px);   /* 改这个值调英文下移距离 */
}

.share-subtitle {
  font-size: 33px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0 0 20px 0;
  line-height: 1.6;
}

.share-desc {
  font-size: 24px;
  font-weight: 400;
  color: #B3B3B3;
  margin: 0;
  line-height: 1.5;
  white-space: pre-line;
}

/* 仅英文生效：模块四介绍文字左右两端对齐（英文文案已去掉 \n） */
:lang(en) .share-desc {
  text-align: justify;
}

/* 模块四动效独立拆分：左下角文字（.share-content 副标题+描述）与人物图（home-4-people.png）
   各自叠加独立入场动效，透明度与父层 .section-inner 相乘生效；
   隐藏态不设过渡，切页离开瞬间重置，切回来完整重播 */

/* 模块四：左下角文字（副标题+描述）入场；
   改 0.8s 调动画时长，改末尾 0s 调延迟，改 translateY(24px) 调上移幅度 */
.reveal-section .share-text .share-content {
  opacity: 0;
  transform: translateY(40px);
}

.reveal-section.is-visible .share-text .share-content {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.2s ease 0s,
    transform 1s ease 0s;
}

/* 模块四：人物图（home-4-people.png）入场——渐入上移；
   改 0.8s 调动画时长，改末尾 0s 调延迟，改 translateY(24px) 调上移幅度 */
.reveal-section .section-overlay-share {
  opacity: 0;
  transform: translateX(80px);
}

.reveal-section.is-visible .section-overlay-share {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.2s ease 0s,
    transform 1.2s ease 0s;
}

/* 模块五：文字 */
.mode-text {
  position: absolute;
  top: 6%;
  left: 0;
  width: 100%;
  z-index: 10;
  text-align: center;
  padding-top: 8.5%;
}

.mode-title {
  font-size: 42px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0;
  line-height: 0.3;
}

.mode-divider {               /* 标题下方的分割线 */
  width: 330px;
  height: 1px;
  background-color: #1a1a1a;
  margin: 40px auto 0;
}

.mode-desc {
  font-size: 20px;
  font-weight: 400;
  color: #B3B3B3;
  margin: 20px auto 0;
  max-width: 70%;
  line-height: 1.8;
  text-align: center;
  white-space: pre-line;
}

/* 仅英文生效：缩小模块五文字容器宽度，数值可改 */
:lang(en) .mode-desc {
  font-size: 18px;
  max-width: 45%;
}

/* 模块五动效独立拆分：渲染文字（.mode-text 标题+分割线+描述，整体一个动效）与
   地球图（home-5-earth.png）各自叠加独立入场动效，透明度与父层 .section-inner 相乘生效；
   隐藏态不设过渡，切页离开瞬间重置，切回来完整重播 */

/* 模块五：渲染文字整体入场（标题+分割线+描述一起动）；
   改 0.8s 调动画时长，改末尾 0s 调延迟，改 translateY(24px) 调上移幅度 */
.reveal-section .mode-text {
  opacity: 0;
  transform: translateY(100px);
}

.reveal-section.is-visible .mode-text {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0s,
    transform 0.2s ease 0s;
}

/* 模块五：地球图（home-5-earth.png）入场——渐入上移；
   改 0.8s 调动画时长，改末尾 0s 调延迟，改 translateY(24px) 调上移幅度 */
.reveal-section .section-overlay-mode {
  opacity: 0;
  transform: translateY(120px);
}

.reveal-section.is-visible .section-overlay-mode {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.0s ease 0s,
    transform 1.2s ease 0s;
}

/* 模块六：文字 */
.extra-text {
  position: absolute;
  top: 6%;
  left: 0;
  width: 100%;
  z-index: 10;
  text-align: center;
  padding-top: 10%;
}

.extra-title {                /* 标题：“全线品质严格管控” */
  font-size: 46px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0;
  line-height: 0.3;
}

.extra-divider {              /* 标题下方的分割线 */
  width: 330px;
  height: 1px;
  background-color: #1a1a1a;
  margin: 40px auto 0;
}

.extra-card {                 /* 卡片文字容器（已手动对齐，改 top/left 调位置） */
  position: absolute;
  top: 200%;
  left: 53%;
  max-width: 32%;
  text-align: left;
}

/* 仅英文生效：模块六卡片容器（标题+描述同一个容器）宽度控制，改 max-width 即可 */
:lang(en) .extra-card {
  max-width: 28%;
}

.extra-card-title {           /* 卡片标题：“优秀的团队” */
  font-size: 38px;
  font-weight: 500;
  color: #FFFFFF;
  margin: 0 0 18px 0;
  line-height: 1.4;
}

.extra-card-desc {
  font-size: 24px;
  font-weight: 400;
  color: #FFFFFF;
  margin: 0;
  line-height: 1.5;
  white-space: pre-line;
}

/* 仅英文生效：模块六文字大小单独调节，改 font-size 即可 */
:lang(en) .extra-title {          /* 大标题：“Strict Quality Control...” */
  font-size: 46px;
}

:lang(en) .extra-card-title {     /* 卡片标题：“Excellent Team” */
  font-size: 40px;
}

:lang(en) .extra-card-desc {      /* 卡片描述 */
  font-size: 24px;
}

/* 模块六动效独立拆分：左图（home-6-person.png）一个动效；右图（home-6-green.png）
   带着卡片文字（.extra-card）与钻石图标一起一个动效（三者同一组时长/延迟）；
   透明度与父层 .section-inner 相乘生效；隐藏态不设过渡，切页离开瞬间重置，切回来完整重播 */

/* 模块六：左图（home-6-person.png）入场——渐入上移；
   改 0.8s 调动画时长，改末尾 0s 调延迟，改 translateY(24px) 调上移幅度 */
.reveal-section .section-overlay-extra-person {
  opacity: 0;
  transform: translateY(80px);
}

.reveal-section.is-visible .section-overlay-extra-person {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0s,
    transform 0.8s ease 0s;
}

/* 模块六：右图组（绿色卡片图+钻石图标+卡片文字）一起入场，三行隐藏/可见态参数保持一致；
   改 0.8s 调动画时长，改末尾 0s 调延迟，改 translateY(24px) 调上移幅度 */
.reveal-section .section-overlay-extra-green,
.reveal-section .section-overlay-extra-diamond {
  opacity: 0;
  transform: translateY(80px);
}

.reveal-section .extra-text .extra-card {
  opacity: 0;
  transform: translateY(80px);
}

.reveal-section.is-visible .section-overlay-extra-green,
.reveal-section.is-visible .section-overlay-extra-diamond {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0s,
    transform 0.8s ease 0s;
}

.reveal-section.is-visible .extra-text .extra-card {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0s,
    transform 0.8s ease 0s;
}




/* ============================================================
 * 移动端适配（<= 1024px）：禁用画布缩放并逐模块接管布局，
 * !important 覆盖行内 transform（JS 缩放值）；仅手机端生效，不影响桌面端，
 * 字号统一用 vw（375px 屏宽基准：16px≈4.27vw），保证各手机每行字数与换行一致，
 * 各数值按注释提示自行微调；手机端英文单独微调用 :lang(en) 写在媒体查询内
 * ============================================================ */
@media (max-width: 1024px) {
  /* 全部流式项禁止被 flex 压缩：内容总高超出整屏时，
     细元素（1px 分割线等）会被默认收缩直接压成 0 而消失，
     超出部分应落到底部裁切区而不是压缩内容；
     模块一 .hero-text、模块四 .share-text 已打平（display: contents），其子项需单独列出 */
  .home .fullscreen-section .section-inner > *,
  .home .hero-text > *,
  .home .share-text > * {
    flex-shrink: 0;
  }

  .section-canvas {
    transform: none !important;
    width: 100%;
    height: 100%;
  }

  /* ---------- 模块一 ---------- */

  /* 内容容器改 flex 纵向文档流：子元素顺序用 order 控制，间距用 margin 控制，
     不再依赖 top/bottom 定位（仅媒体查询内生效，不影响桌面端） */
  .home .fullscreen-section:nth-child(1) .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  /* 打平文字容器：标题/副标题/按钮成为独立流式项，才能与图片穿插排序 */
  .hero-text {
    display: contents;
  }

  /* 模块一间距统一用 vh（按约 700px 屏高换算：8px≈1vh、16px≈2vh、20px≈3vh），
     矮屏自动收紧防裁切、高屏自动拉开 */
  .hero-title {                 /* 主标题 */
    order: 1;
    font-size: 7.47vw;
    margin: 0 0 1vh 0;
    text-align: center;
  }

  :lang(en) .hero-title {       /* 主标题（英文单独调节字号） */
    font-size: 7.47vw;
  }

  .hero-subtitle {              /* 副标题 */
    order: 2;
    font-size: 6.93vw;
    line-height: 1.4;
    margin: 0;
    text-align: center;
  }

  :lang(en) .hero-subtitle {    /* 副标题（英文单独调节字号） */
    font-size: 6.93vw;
  }

  /* CGM 大图：进入文档流，排在副标题与按钮之间（改 max-width 调宽、max-height 调高上限） */
  .section-overlay-hero {
    order: 3;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 84%;
    max-height: 32vh;
    margin: 2vh 0 0 0;
  }

  .hero-btn {                   /* 按钮 */
    order: 4;
    font-size: 4.27vw;
    padding: 10px 28px;
    margin: 3vh 0 0 0;
  }

  :lang(en) .hero-btn {         /* 按钮（英文单独调节字号） */
    font-size: 4.27vw;
  }

  /* 小标语：流式项排在按钮下方，放开换行（桌面是 nowrap） */
  .hero-smallword {
    order: 5;
    position: static;
    width: 100%;
    box-sizing: border-box;
    padding: 18px 14% 0;
    font-size: 3.2vw;
    letter-spacing: 0px;
    white-space: normal;
    text-align: center;
  }

  :lang(en) .hero-smallword {
    font-size: 3.2vw;
    transform: none;
  }

  /* 上层小图：流式项排在最底部（改 max-width 调宽、max-height 调高上限） */
  .section-overlay-hero-small {
    order: 6;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 60%;
    max-height: 14vh;
    margin: 3vh 0 0 0;
  }

  :lang(en) .section-overlay-hero-small {
    max-width: 60%;
    max-height: 14vh;
        margin: 4vh 0 0 0;
  }

  /* ---------- 模块二 ---------- */

  /* 内容容器改 flex 纵向文档流：文字块在上、人物图在下；
     顶对齐 + padding-top 预留固定导航栏（手机端高 60px），
     避免内容偏高时垂直居中导致标题被导航栏遮挡/裁切 */
  .home .fullscreen-section:nth-child(2) .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 76px 0 3vh;
  }

  /* 文字块（标题/描述/按钮）：取消绝对定位，通宽 + 左右 padding 控制留白；
     order 控制图文先后：文字 1 / 人物图 2 = 文字在上，两个数字互换即图在上 */
  .section-text {
    order: 1;
    position: static;
    width: 100%;
    box-sizing: border-box;
    max-width: none;
    padding: 0 12%;
    text-align: center;
  }

  :lang(en) .section-text {
    padding: 0 8%;
    max-width: none;
  }

  .section-title {              /* 标题：“服务与支持” */
    font-size: 8vw;
    margin: 0 0 3vh 0;
  }

  :lang(en) .section-title {    /* 标题（英文单独调节字号） */
    font-size: 8vw;
  }

  .section-desc {               /* 描述文案 */
    font-size: 4.27vw;
    margin: 0 0 4vh 0;
    white-space: normal;
  }

  :lang(en) .section-desc {     /* 描述文案（英文单独调节字号） */
    font-size: 3.73vw;
    text-align: center;
  }

  .section-btn {                /* 按钮 */
    font-size: 4.27vw;
    padding: 10px 24px;
  }

  :lang(en) .section-btn {      /* 按钮（英文单独调节字号） */
    font-size: 4.27vw;
  }

  /* 箭头缩小（改 width 调横线长度） */
  .btn-arrow {
    width: 3.73vw;
    height: 0.2vh;
  }

  .btn-arrow::after {
    width: 2.2vw;
    height: 0.2vh;
  }

  /* 人物图：进入文档流（改 max-width 调宽、max-height 调高上限；
     与 .section-text 的 order 数字互换即可调换图文先后） */
  .section-overlay-daynight {
    order: 2;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 120%;
    max-height: 50vh;
    margin: 4vh 0 0 0;
  }

  :lang(en) .section-overlay-daynight {
    max-width: 100%;
    max-height: 42vh;
  }

  /* ---------- 模块三 ---------- */

  /* 内容容器改 flex 纵向文档流：文字在上、人物插图在下；
     顶对齐 + padding-top 预留固定导航栏（同模块一/二） */
  .home .fullscreen-section:nth-child(3) .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 88px 0 3vh;
  }

  /* 卡片文字块：取消绝对定位，通宽 + 左右 padding 控制留白 */
  .app-text {
    order: 1;
    position: static;
    width: 100%;
    box-sizing: border-box;
    padding: 0 12%;
    text-align: center;
  }

  .app-title {                /* 标题：“我们的使命” */
    font-size: 8vw;
    margin: 0 0 2vh 0;
    color: #1a1a1a;
  }

  :lang(en) .app-title {      /* 标题（英文单独调节字号） */
    font-size: 8vw;
  }

  .app-desc {                 /* 使命描述；手机端换行由语言包中的 | 控制（mobileText 转成真换行，pre-line 使其生效） */
    font-size: 4.8vw;
    line-height: 1.7;
    color: #B3B3B3;
    white-space: pre-line;
  }

  :lang(en) .app-desc {   /* 使命描述（英文单独调节字号） */
    padding: 0 2%;
    font-size: 4.27vw;
  }

  /* 青色卡片：手机端隐藏 */
  .section-overlay-app-green {
    display: none;
  }

  /* 人物插图：进入文档流，排在文字下方（改 max-width 调宽、max-height 调高上限） */
  .section-overlay-app {
    order: 2;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 90%;
    max-height: 52vh;
    margin: 8vh 0 0 0;
  }

  /* ---------- 模块四 ---------- */

  /* 内容容器改 flex 纵向文档流：主标题 → 分割线 → 人物图 → 副标题/描述；
     顶对齐 + padding-top 预留固定导航栏（同模块一/二） */
  .home .fullscreen-section:nth-child(4) .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 86px 0 3vh;
  }

  /* 打平文字容器：主标题/分割线/内容块成为独立流式项，才能与图片穿插排序 */
  .share-text {
    display: contents;
  }

  .share-main-title {         /* 主标题 */
    order: 1;
    font-size: 5.6vw;
    line-height: 1.0;
    margin: 0;
    padding: 0 8%;
    text-align: center;
  }

  :lang(en) .share-main-title {        /* 英文单独调节字号与左右收窄 */
    font-size: 4.8vw;
    padding: 0 10%;
    line-height: 1.3;
  }

  .share-divider {            /* 标题下方分割线；防压缩规则见媒体查询顶部（1px 高，
                                 内容超出时会被 flex 收缩压成 0 而消失，英文版文案长先触发） */
    order: 2;
    width: 200px;
    margin: 3vh 0 0 0;
  }

  /* 英文版单独保底：显式重申高度/颜色，防止其它规则覆盖；
     改 width 调线宽、margin-top 调与标题的间距 */
  :lang(en) .share-divider {
    display: block;
    height: 1px;
    background-color: #1a1a1a;
    width: 200px;
    margin: 2vh 0 0 0;
  }

  /* 人物图：进入文档流，排在分割线与内容块之间（改 max-width 调宽、max-height 调高上限） */
  .section-overlay-share {
    order: 3;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 80%;
    max-height: 38vh;
    margin: 3vh 0 0 0;
  }

  /* 人物图动效：桌面 translateX(80px) 从右入场，手机端覆盖为从下往上 */
  .reveal-section .section-overlay-share {
    opacity: 0;
    transform: translateY(48px);
  }

  .reveal-section.is-visible .section-overlay-share {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 0.8s ease 0s,
      transform 0.8s ease 0s;
  }

  /* 内容块（副标题+描述）：取消绝对定位，排在人物图下方 */
  .share-content {
    order: 4;
    position: static;
    width: 100%;
    box-sizing: border-box;
    max-width: none;
    padding: 3vh 10% 0;
    text-align: center;
  }

  :lang(en) .share-content {  /* 英文单独调节左右留白（控制换行） */
    padding: 0 4% 0;
    max-width: none;
  }

  /* 手机端英文：覆盖桌面端的 transform 下移（选择器与桌面端同级） */
  :lang(en) .reveal-section .share-text .share-content {
    transform: none;
  }

  :lang(en) .reveal-section.is-visible .share-text .share-content {
    transform: none;
  }

  .share-subtitle {           /* 副标题 */
    font-size: 5.33vw;
    margin: 0 0 2vh 0;
  }

  :lang(en) .share-subtitle { /* 副标题（英文单独调节字号） */
    font-size: 3.73vw;
  }

  .share-desc {               /* 描述文案；两端对齐（末行短文字默认回左对齐） */
    font-size: 4.8vw;
    padding: 0 2%;
    text-align: justify;
    white-space: normal;
  }

  :lang(en) .share-desc {     /* 描述文案（英文单独调节字号与左右内边距） */
    font-size: 3.73vw;
    padding: 0 2%;
    text-align: center;
  }

  /* ---------- 模块五 ---------- */

  /* 内容容器改 flex 纵向文档流：文字块在上、地球图在下；
     顶对齐 + padding-top 预留固定导航栏（同模块一/二） */
  .home .fullscreen-section:nth-child(5) .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 88px 0 3vh;
  }

  /* 文字块（标题+分割线+描述）：取消绝对定位 */
  .mode-text {
    order: 1;
    position: static;
    width: 100%;
    box-sizing: border-box;
    padding: 0;
  }

  .mode-title {               /* 标题 */
    font-size: 7.47vw;
    line-height: 1.2;
    margin: 0;
  }

  :lang(en) .mode-title {     /* 标题（英文单独调节字号） */
    font-size: 6.93vw;
    padding: 0 2%;
  }

  .mode-divider {             /* 分割线 */
    width: 200px;
    margin: 3vh auto 0;
  }

  .mode-desc {                /* 描述文案 */
    font-size: 4vw;
    max-width: none;
    padding: 0 6%;
    margin: 3vh auto 0;
    box-sizing: border-box;
    white-space: normal;
  }

  :lang(en) .mode-desc {      /* 描述文案（英文单独调节字号）*/
    font-size: 4vw;
    max-width: none;
  }

  /* 地球图：进入文档流，排在文字块下方（改 max-width 调宽、max-height 调高上限） */
  .section-overlay-mode {
    order: 2;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 44vh;
    margin: 4vh 0 0 0;
  }

  /* ---------- 模块六 ---------- */

  /* 最后一个模块：高度由内容撑开，避免 100vh 产生大片留白；
     min-height 补偿与其他页面最后模块的高度差（844 - 695.5 ≈ 148.5px） */
  .home .fullscreen-section:nth-child(6) {
    height: auto;
    min-height: auto;
  }

  /* 内容容器改 flex 纵向文档流：文字块（标题+分割线+卡片文字）在上、人物图在下；
     顶对齐 + padding-top 预留固定导航栏（同模块一/二）；
     增加 padding-bottom 补偿与其他页面最后模块的高度差 */
  .home .fullscreen-section:nth-child(6) .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 88px 0 21vh;
  }

  /* 文字块（标题+分割线+卡片文字）：取消绝对定位 */
  .extra-text {
    order: 1;
    position: static;
    width: 100%;
    box-sizing: border-box;
    padding: 0;
  }

  .extra-title {              /* 标题 */
    font-size: 6.93vw;
    line-height: 1.3;
    margin: 0;
  }

  :lang(en) .extra-title {    /* 标题（英文单独调节字号） */
    font-size: 5.87vw;
        padding: 0 2%;
  }

  .extra-divider {            /* 分割线 */
    width: 200px;
    margin: 3vh auto 0;
  }

  /* 绿色卡片与钻石图标：手机端隐藏（同模块三青色卡片） */
  .section-overlay-extra-green,
  .section-overlay-extra-diamond {
    display: none;
  }

  /* 卡片文字：绿色卡片隐藏后居中排列，文字改深色（改 padding 调左右留白） */
  .extra-card {
    position: static;
    transform: none;
    width: 100%;
    box-sizing: border-box;
    max-width: none;
    margin: 4vh 0 0 0;
    padding: 0 12%;
    text-align: center;
  }

  :lang(en) .extra-card {     /* 英文单独调左右内留白 */
    max-width: none;
    margin: 2vh 0 0 0;
    padding: 0 8%;
  }

  /* 卡片入场动效：隐藏/可见两态保持一致（文档流定位，仅上移渐入） */
  .reveal-section .extra-text .extra-card {
    opacity: 0;
    transform: translateY(24px);
  }

  .reveal-section.is-visible .extra-text .extra-card {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 0.8s ease 0s,
      transform 0.8s ease 0s;
  }

  .extra-card-title {         /* 卡片标题；卡片隐藏后文字改深色；
                                margin 末值调标题与描述的间距 */
    font-size: 6.4vw;
    margin: 0 0 3vh 0;
    color: #1a1a1a;
  }

  :lang(en) .extra-card-title {  /* 卡片标题（英文单独调节字号） */
    font-size: 6.4vw;
  }

  .extra-card-desc {          /* 卡片描述；卡片隐藏后文字改深色 */
    font-size: 4.53vw;
    color: #B3B3B3;
    white-space: normal;
  }

  :lang(en) .extra-card-desc {   /* 卡片描述（英文单独调节字号） */
    font-size: 4.27vw;
  }

  /* 人物图：进入文档流，排在文字块下方（改 max-width 调宽、max-height 调高上限） */
  .section-overlay-extra-person {
    order: 2;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 90%;
    max-height: 34vh;
    margin: 4vh 0 0 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .reveal-section .section-inner,
  .reveal-section .hero-btn,
  .reveal-section .section-overlay-hero {
    transition: none;
    opacity: 1;
    transform: none;
  }
}
</style>
